import shippingMethodGetters from '../../getters/shippingMethodGetters';
import { CheckoutNavigationStatus } from './useCheckoutNavigation';
import { useShippingProvider } from '~/composables/custom/useShippingProvider';
import useCheckoutForm from '~/composables/custom/useCheckoutForm';
import { useCheckout } from '~/composables/custom/useCheckout';
import { useUser } from '~/composables/custom/useUser/useUser';
import { useCart } from '~/composables/custom/useCart/useCart';
import { type ShippingMethodInfo, ShippingType } from '~/types/shipping-methods';
import type { Address, ShippingMethod } from '~/types/GraphQL';

export const useBillingNavigation = () => {
  const {
    updating: savingShipping,
    shippingMethodsByCart: shippingMethods,
  } = useShippingProvider();
  const { cart } = useCart();
  const shippingMethod = useState('shipping-method');
  const billingAddress = useState('billing-address');
  const { error: errorUser, updating: updatingCustomer } = useUser();
  const { isVisible } = useCheckoutForm('billing');
  const { updating, errors, resetErrors } = useCheckout();
  const { $domain } = useNuxtApp();

  const hasErrors = computed(() => errorUser.value.saveBirthDate || errorUser.value.login || errors.value);

  const nextState: Ref<CheckoutNavigationStatus> = computed(() => {
    if (savingShipping.value || updating.value || updatingCustomer.value) {
      return CheckoutNavigationStatus.LOADING;
    }

    const selectedShippingMethod = shippingMethods.value?.find(method => method.id === cart.value.shippingInfo?.shippingMethod?.id);
    if (
      hasErrors.value
      || !shippingMethod.value?.key
      || (!billingAddress.value && !isVisible.value)
      || (shippingMethod.value?.key === ShippingType.SHIPPING_SAME && billingAddress.value?.country !== $domain.countryCode)
      || (shippingMethodGetters.isClickAndCollect(selectedShippingMethod as ShippingMethodInfo) && !shippingMethodGetters.isShippingAvailable(selectedShippingMethod as ShippingMethodInfo, cart.value)
      )) {
      return CheckoutNavigationStatus.MISSING_INFO;
    }

    return shippingMethod.value.key === ShippingType.SHIPPING_SAME ? CheckoutNavigationStatus.TO_PAYMENT : CheckoutNavigationStatus.TO_SHIPPING;
  });

  return {
    nextState: computed(() => nextState.value),
    shippingMethod: computed(() => shippingMethod.value),
    billingAddress: computed(() => billingAddress.value),
    // eslint-disable-next-line @stylistic/max-statements-per-line
    setShippingMethod: (value?: ShippingMethod) => { if (shippingMethod.value) { resetErrors(); } shippingMethod.value = value; },
    setBillingAddress: (value: Address) => { billingAddress.value = value; },
  };
};
